<template>
  <v-dialog 
  v-model="dialog" 
  :max-width="options.width" 
  @keydown.esc="cancel()"
  persistent
  content-class="border-radius"
  transition="dialog-bottom-transition">
    <v-card>
      <v-layout pt-3 pl-3 pr-3 pb-0>
        <v-icon color="amber lighten-2" style="font-size: 36px;">warning</v-icon>
        <v-layout column ml-4>
          <div class="font-weight-bold mb-2">
            {{ title }}
          </div>
          <div v-show="!!message">
            {{ message }}
          </div>
        </v-layout>
      </v-layout>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn  
        text
        outlined
        class="mr-1 text--text"
        @click.native="cancel()">
          Cancel
        </v-btn>
        <v-btn 
        color="color1"
        class="ma-0" 
        text
        outlined
        @click.native="agree()">Yes</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  /**
   * Vuetify Confirm Dialog component
   *
   * Insert component where you want to use it:
   * <confirm ref="confirm"></confirm>
   *
   * Call it:
   * this.$refs.confirm.open('Delete', 'Are you sure?', { color: 'red' }).then((confirm) => {});
   *
   * Alternatively you can place it in main App component and access it globally via this.$root.$confirm
   * <template>
   *   <v-app>
   *     ...
   *     <confirm ref="confirm"></confirm>
   *   </v-app>
   * </template>
   *
   * mounted() {
   *   this.$root.$confirm = this.$refs.confirm.open;
   * }
   */
  export default {
    data () {
      return {
        dialog: false,
        resolve: null,
        reject: null,
        message: null,
        title: null,
        options: {
          color: 'primary',
          width: 290
        }
      }
    },
    methods: {
      open (title, message, options) {
        this.dialog = true
        this.title = title
        this.message = message
        this.options = Object.assign(this.options, options)
        return new Promise((resolve, reject) => {
          this.resolve = resolve
          this.reject = reject
        })
      },
      agree () {
        this.resolve(true)
        this.dialog = false
      },
      cancel () {
        this.resolve(false)
        this.dialog = false
      }
    }
  }
</script>

<style scoped lang="scss">
.v-dialog__content {
  align-items: flex-end;
}
::v-deep .border-radius {
  border-radius: 13px!important;
}
</style>
